import React, { useState, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../config/firebase"; // adjust the path to match your project
import { toast } from "react-toastify";
import { trackEvent, AUTH_EVENTS } from "../../services/analytics";

const ForgotPasswordForm: React.FC = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // useLayoutEffect(() => {
  //   const timeout = setTimeout(() => {
  //       document.body.style.overflow = 'hidden';
  //     }, 0); // let ResizeObserver finish
    
  //     return () => {
  //       clearTimeout(timeout);
  //       setTimeout(() => {
  //         document.body.style.overflow = '';
  //       }, 0);
  //     };
  // }, []);

  const validateEmail = (email: string, validationType: 'not_empty' | 'valid_email'): boolean => {
    if (!email.trim()) {
      setEmailError("Email is required");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email) && validationType === 'valid_email') {
      setEmailError("Please enter a valid email");
      return false;
    }
    setEmailError("");
    return true;
  };

  const handleForgotPasswordRequest = async () => {
    // Step 1: Validate input
    if (!validateEmail(email, 'valid_email')) return;

    setIsLoading(true);

    // Track password reset request
    trackEvent(AUTH_EVENTS.PASSWORD_RESET_REQUESTED);

    try {
      await sendPasswordResetEmail(auth, email, {
        url: process.env.REACT_APP_FRONTEND_URL!, // or 'develop' or 'production'
        handleCodeInApp: true,
      });
      toast.success("Password reset email sent! Please check your inbox.");
      //Clear email input
      setEmail("");
      //Clear email error
      setEmailError("");
    } catch (error: any) {
      console.error("Error sending reset email:", error);
      if (error.code === 'auth/user-not-found') {
        setEmailError("No user found with this email.");
      } else {
        setEmailError("Failed to send reset email. Try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  }

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleForgotPasswordRequest();
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center px-4 sm:px-6 bg-nova-color font-family-messina-sans-regular">
      <form onSubmit={handleFormSubmit} className="w-full max-w-md flex flex-col items-center space-y-6 p-6 bg-nova-color login-form mt-8 sm:mt-32">
        {/* Logo */}
        <Link to="/login" className="flex-shrink-0">
        <img src="/assets/images/Nova.png" alt="Nova" className="h-10 w-auto mb-6 sm:mb-8" />
        </Link>
        {/* Make it text title */}
        {/* <h1 className="text-2xl mb-6 sm:mb-8 font-family-messina-sans">Forgot Password</h1> */}
        {/* <img src="/assets/images/nova-login-logo-svg.svg" alt="Nova Login" className="h-10 w-auto mb-6 sm:mb-8" /> */}

        {/* Email Input */}
        <div className="w-full sm:w-[25.8125rem]">
          <input
            type="text"
            placeholder="Enter Email"
            className={`w-full border-b ${emailError ? 'border-red-500' : 'border-gray-300'} px-0 py-2 text-sm focus:outline-none placeholder:font-normal font-family-messina-sans-regular`}
            style={{ backgroundColor: '#F8F7F2', '--tw-placeholder-color': '#939393' } as React.CSSProperties}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (emailError) validateEmail(e.target.value, 'not_empty');
            }}
            onBlur={() => validateEmail(email, 'not_empty')}
          />
          {emailError && <p className="text-red-500 text-xs mt-1">{emailError}</p>}
        </div>

        {/* Sign In Button */}
        <button
          type="submit"
          disabled={isLoading}
          className={`w-full sm:w-[25.8125rem] border px-5 py-3 sm:py-4 rounded-full text-sm sm:text-base font-medium transition flex items-center justify-center gap-3 uppercase min-h-[3rem] navbar-menu-item ${
            isLoading 
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
              : 'text-black hover:bg-gray-200'
          }`}
          style={{ paddingTop: "1rem" }}
        >
          {isLoading ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-500"></div>
              SENDING REQUEST...
            </>
          ) : (
            'SUBMIT FORGOT PASSWORD REQUEST'
          )}
        </button>
        <div className="w-full text-center mt-2">
          <Link to="/login" className="text-sm text-[#939393] hover:underline" style={{ fontSize: "0.8rem" }} >Back to Login</Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
